import api from './api/api';

export const cadastrar = async (conversa) => {
  return api().post('/conversa/cadastrar', conversa);
}

export const listConversas = async (pagina, tamanho) => {
  return api().get(`/conversa/getByUser?pagina=${pagina}&tamanho=${tamanho}`)
}

export const listConversasBySolicitacao = async (idSolicitacao, tipoConversa, pagina, tamanho) => {
  return api().get(`/conversa/bySolicitacao?idSolicitacao=${idSolicitacao}&tipoConversa=${tipoConversa}&pagina=${pagina}&tamanho=${tamanho}`)
}

export const findConversaById = async (id) => {
  return api().get(`/conversa/getById/${id}`)
}

export const responderMensagem = async (resposta) => {
  return api().post('/mensagem/resposta', resposta)
}

export const marcarMensagemComoLida = async (id) => {
  return api().put(`/mensagem/lido/${id}`)
}

export const finalizarConversa = async (id) => {
  return api().put(`/conversa/encerrar/${id}`)
}
